// src/components/dashboard/customStudy/SubdeckSelector.tsx
// REFATORADO: Verde Militar + Ícones Lucide + FORMATO DE LISTA

import React from 'react';
import { CustomStudyDeck, CustomStudySubdeck } from './types';
import { FileText, Check } from 'lucide-react';

interface SubdeckSelectorProps {
    subdecks: CustomStudySubdeck[];
    selectedSubdeckIds: string[];
    decks: CustomStudyDeck[];
    onToggle: (subdeckId: string) => void;
    loading: boolean;
}

const SubdeckSelector: React.FC<SubdeckSelectorProps> = ({
    subdecks,
    selectedSubdeckIds,
    decks,
    onToggle,
    loading
}) => {
    const getDeckName = (deckId: string) => {
        return decks.find(d => d._id === deckId)?.name || 'Desconhecido';
    };

    if (loading) {
        return (
            <div className="selector-section">
                <div className="selector-loading">
                    <div className="spinner"></div>
                    <p>Carregando subdecks...</p>
                </div>
            </div>
        );
    }

    if (subdecks.length === 0) {
        return (
            <div className="selector-section">
                <div className="selector-empty">
                    <p>Nenhum subdeck encontrado nos decks selecionados</p>
                </div>
            </div>
        );
    }

    return (
        <div className="selector-section">
            <div className="selector-header">
                <h3>
                    <FileText size={22} style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '10px' }} />
                    Passo 3: Selecione os Subdecks
                </h3>
                <span className="selection-count">
                    {selectedSubdeckIds.length} selecionado{selectedSubdeckIds.length !== 1 ? 's' : ''}
                </span>
            </div>

            {/* FORMATO DE LISTA ao invés de grid */}
            <div className="selector-list">
                {subdecks.map(subdeck => {
                    const isSelected = selectedSubdeckIds.includes(subdeck._id);
                    const deckName = getDeckName(subdeck.deckId);

                    return (
                        <button
                            key={subdeck._id}
                            className={`selector-list-item ${isSelected ? 'selected' : ''}`}
                            onClick={() => onToggle(subdeck._id)}
                        >
                            <div className="list-item-checkbox">
                                {isSelected && <Check size={16} />}
                            </div>

                            <div className="list-item-content">
                                <span className="list-item-name">{subdeck.name}</span>
                                <span className="list-item-deck">{deckName}</span>
                            </div>

                            <div className="list-item-stats">
                                <span className="list-item-badge">
                                    {subdeck.cardCount} card{subdeck.cardCount !== 1 ? 's' : ''}
                                </span>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default SubdeckSelector;